import React from 'react';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import HoverTooltip from '../interface/hoverTooltip';
import Constants from '../../../../definitions/constants';
import { intl } from '../../../../locales/localesConfig';

const Select = React.forwardRef((props, ref) => {
  const {
    className,
    id,
    value,
    onChange,
    labelLocale,
    emptyOption,
    options,
    onClick,
    onKeyEnter,
    onKeyEsc,
    formatter,
    disabled,
    propRef,
    optionsTooltipsLocalesPath,
  } = props;
  const dataPath = props["data-path"];
  const dataSelectlist = props["data-selectlist"];
  const dataIsOption = props["data-isoption"];  
  return (
    <label className={"custom-input custom-matter-select" + (className ? " " + className : "")}>
      <select 
        id={id}
        ref={propRef || ref}
        data-path={dataPath}
        data-selectlist={dataSelectlist}
        data-isoption={dataIsOption}
        onChange={onChange}
        onClick={onClick}
        className="select-text"
        value={value}
        disabled={disabled}
        required
        onKeyDown={(onKeyEnter || onKeyEsc) ? InterfaceTooling.getOnKeyEnterOrEscHandler(onKeyEnter,onKeyEsc) : null}
      >
        {emptyOption && (<option value=""></option>)}
        {options && options.map( (item,i) => {
          return (<option key={i} value={item.value}>{formatter ? formatter(item.label) : item.label}</option>);
        })}
      </select>
      <span className="select-label">{labelLocale}</span>
      {(optionsTooltipsLocalesPath && value) && (
        <HoverTooltip 
          toolTip={intl.formatMessage({id: optionsTooltipsLocalesPath+"."+value})}
          toolTipType={Constants.interface.toolTip.formItemHelp}
          enterDelay={300} 
          leaveDelay={100}
        >
          <i 
            className="fas fa-question"
          />
        </HoverTooltip>
      )}
    </label>
  );
});

export default Select;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/select.jsx